module.exports = __webpack_public_path__ + "a5d4cd69490b9eeeb04de9a5d840d55d.png";